<template>
  <Tooltip
      tooltip-class="offer-item-spo"
      :max-width="700"
      :to="target"
      :to-element="targetElement"
      :enabled="enabled"
      @show="onShow"
  >
    <div v-if="!!info && !info.noPackage" class="offer-item-spo__body">
      <div>
          <span>
            <div class="offer-item-spo__name" :style="`background: ${info.backgroundColor}`">
              {{ info.name }}
            </div>
          </span>
        <span v-if="!!info.expiresInText" class="offer-item-spo__expires-in mb-2">
              <svg-icon icon="warn-triangle" class="text-system-10" width="12" height="12" view-box="0 0 16 16"/>
              <span class="font-weight-semi" v-html="info.expiresInText"></span>
          </span>
      </div>
      <div v-if="!info.userAuthorized">
        {{ $res.Views.PackageSearch_PleaseAuthorizeToSeePromotionConditions }}
      </div>
      <div v-if="info.agencySpecific" class="offer-item-spo__agency-specific mb-1">
        <span class="font-weight-semi">{{ $res.Views.PackageSearch_OfferOnlyForRetailAgencies }}</span>
      </div>
      <ul v-if="info.promotions.length > 0" class="offer-item-spo__promotions">
        <li v-for="promotion in info.promotions" :key="promotion">
          <svg-icon icon="approved"/>
          {{ promotion }}
        </li>
      </ul>
    </div>
    <div v-if="showFooter" class="offer-item-spo__footer">
      {{ info.expirationDateText }}
    </div>
    <div v-if="hotelPromotions.length > 0">
      <div v-for="(hotelPromotion, ix) in hotelPromotions" :key="ix" class="">
        <div class="offer-item-spo__body">
          <div>
            <span class="offer-item-spo__name" :style="getPromotionStyle(hotelPromotion)">
              {{ hotelPromotion.badgeTitle }}
            </span>
            <span class="offer-item-spo-theme__attention" v-if="hotelPromotion.attention">
                <svg-icon icon="warn-triangle" class="text-system-10" width="12" height="12"
                          view-box="0 0 16 16"></svg-icon>
                <strong>{{ hotelPromotion.attention }}</strong>
              </span>
          </div>
          <div v-if="hotelPromotion.descriptions.length > 0" class="offer-item-spo-theme__descriptions">
            <div v-for="description in hotelPromotion.descriptions">
              <svg-icon icon="approved"></svg-icon>
              <span>{{ description }}</span>
            </div>
          </div>
        </div>
        <div v-if="hotelPromotion.limitation" class="offer-item-spo__footer">{{ hotelPromotion.limitation }}</div>
      </div>
    </div>
  </Tooltip>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import Tooltip from "@/common/tooltip/Tooltip.vue";
import Base from "./OfferItemSpoComponentBase";

export default {
  extends: Base,
  components: {
    SvgIcon,
    Tooltip,
  },
};
</script>

<style lang="scss">


.offer-item-spo-theme {
  padding: 0;
  font-size: inherit;

  .offer-item-spo__body {
    padding: 10px 0;
    &:not(:last-child) {
      border-block-end: 2px solid var(--main-40);
    }
  }

  .offer-item-spo__footer {
    background-color: var(--main-40);
    padding: 4px 16px;
  }

  .offer-item-spo__promotions {
    margin-bottom: 0;

    li {
      list-style-type: none;
    }

    svg {
      position: relative;
      top: -1px;
      margin-inline-end: 4px;
    }
  }

  .offer-item-spo__name {
    color: white;
    display: inline-block;
    padding: 1px 8px;
    margin-bottom: 4px;
    border-radius: 2px;
    font-size: 11px;
  }

  .offer-item-spo__expires-in {
    margin-inline-start: 6px;

    svg {
      margin-inline-end: 4px;
      position: relative;
      top: -1px;
    }
  }
}

.offer-item-spo-theme__attention {
  margin-inline-start: 6px;

  strong {
    font-weight: 600;
    margin-inline-start: 4px;
  }
}

.offer-item-spo-theme__descriptions {
  margin-top: 10px;

  svg {
    margin-inline-end: 4px;
    position: relative;
    top: -1px;
  }
}
</style>



